import SocialEntityRepository from '@/shared/http/repositories/socialProject/social-entity'
import { loading, toast } from '@/shared/utils/UIHelper'
import { IsSuccessCode } from '@/shared/utils/API'
import * as mutation from './mutationTypes'
import { actionTypes as action } from './actionTypes'

export const actions = {
  [action.FETCH_SOCIAL_ENTITIES]: async ({ commit }) => {
    try {
      loading.push()

      const res = await SocialEntityRepository.GetAll()
      if (!IsSuccessCode(res)) return Promise.reject()

      commit(mutation.SET_SOCIAL_ENTITIES, res.data.data)
      loading.pop()
      return Promise.resolve()
    } catch (error) {
      loading.pop()
      toast.error('Erro ao carregar entidades sociais', 'ERRO')
    }
  }
}
